import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  DEFAULT_OCPP_SUBPROTOCOL,
  OCPP_SUBPROTOCOL_VALUES,
  OcppSubprotocol,
  normalizeOcppSubprotocol,
  type OcppSubprotocol as OcppSubprotocolType,
} from '@evimo/types/enums/ocpp-subprotocol';

type Props = {
  value?: string;
  onChange?: (value: OcppSubprotocolType) => void;
  disabled?: boolean;
};

export function OrganizationOcppSubprotocolField({
  value = DEFAULT_OCPP_SUBPROTOCOL,
  onChange,
  disabled = false,
}: Props) {
  const { t } = useTranslation('organization');

  const options = OCPP_SUBPROTOCOL_VALUES.map((subprotocol) => ({
    value: subprotocol,
    disabled: subprotocol === OcppSubprotocol.OCPP_2_0_1,
    label:
      subprotocol === OcppSubprotocol.OCPP_1_6
        ? t('ocppSubprotocol.ocpp16Label')
        : t('ocppSubprotocol.ocpp201Label'),
  }));

  return (
    <Select
      value={normalizeOcppSubprotocol(value)}
      onChange={(next) => onChange?.(normalizeOcppSubprotocol(next))}
      options={options}
      disabled={disabled}
      style={{ width: '100%' }}
    />
  );
}
